import AppContainer from './AppContainer.view';

export default AppContainer;
